<div class="send-options-container flex column gap-16">
  <div
    class="send-option-card card-0 card-hover flex full-width align-items-center justify-content-between p-16 cursor-pointer"
    (click)="kaspaClick.emit()"
  >
    <div class="send-option-card__info flex align-items-center gap-16">
      <kc-token-logo
        [ticker]="'KAS'"
        [address]="'0x0000000000000000000000000000000000000000'"
        [size]="'lg'"
      />
      <div class="flex column gap-4">
        <div class="text-gray-90 typo-text-2">Kaspa (L2)</div>
        <div class="text-gray-60 typo-text-1">Send KAS on Layer 2</div>
      </div>
    </div>
  </div>

  <div
    class="send-option-card card-0 card-hover flex full-width align-items-center justify-content-between p-16 cursor-pointer"
    (click)="erc20Click.emit()"
  >
    <div class="send-option-card__info flex align-items-center gap-16">
      <kc-token-logo [ticker]="'ERC20'" [address]="''" [size]="'lg'" />
      <div class="flex column gap-4">
        <div class="text-gray-90 typo-text-2">ERC20 tokens</div>
        <div class="text-gray-60 typo-text-1">Send ERC20 tokens on Layer 2</div>
      </div>
    </div>
  </div>
</div>
